export function warmduration(cf) {
  return Math.round((cf * 118) / 5);
}
